import Vue from "vue";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import VueLodash from "vue-lodash";
import Vuelidate from "vuelidate";

import {
  L
} from 'vue2-leaflet';
import BootstrapVue from "bootstrap-vue";
import {
    FormCheckbox,
    FormFile,
  } from 'bootstrap-vue/es/components';

import globals from "./globals";
//import { popper as Popper } from "@popperjs/core";

import Notifications from 'vue-notification';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.use(Notifications)

// Required to enable animations on dropdowns/tooltips/popovers
//Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(FormCheckbox);
Vue.use(FormFile);


Vue.use(VueLodash, {
  name: "lodash"
});

Vue.use(Vuelidate);

// Global RTL flag
Vue.mixin({
  data: globals
});

new Vue({
  router,
  store,
  L,
  render: h => h(App)
}).$mount("#app");
